/* Version: 3.5.149 */
'use client';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var contactIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    focusable: "false",
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("path", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#FFF",
      strokeWidth: "2",
      d: "M13.26 12.714L7.286 6.74l.332-.648a3.5 3.5 0 1 0-5.31 1.136l.08.072L12.7 17.613l.072.081a3.5 3.5 0 1 0 1.136-5.31l-.648.33z"
    })]
  });
});

export { contactIcon as default };
